import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Badge, Form } from "react-bootstrap";
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import noUserImg from '../assets/images/no_user.png';
import { Link } from 'react-router-dom';
import { AvatarGroup } from 'primereact/avatargroup';
import { Tooltip } from 'primereact/tooltip';
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from 'primereact/multiselect';
import axios from 'axios';
import config from '../config';
import { useAuth } from '../context/AuthContext';
import successVideo from '../assets/video/paperplane.mp4';
import crossVideo from '../assets/video/cross.mp4';
import { Dialog } from "primereact/dialog";
import BrandOverview from "./Brand_Overview";
import BrandIdentity from "./Brand_Identity";
import TargetAudience from "./Target_Audience";
import SocialMediaStrategy from "./SocialMediaStrategy";
import VisualCreativeGuidelines from "./VisualCreativeGuidelines";
import InfluencerCommunityEngagement from "./InfluencerCommunityEngagement";
import AdvertisingTracking from "./AdvertisingTracking";
import CampaignPlanning from "./CampaignPlanning";
import AdditionalNotesResources from "./AdditionalNotesResources";
import BrandProjects from "./BrandProjects";
import PostHistory from "./PostHistory";
import MinutesofMeeting from "./MinutesofMeeting";


const QuotationListview = () => (
    <Card className="view-card">
        <Card.Header className="h6 border-0 bg-light">
            Quotations
        </Card.Header>
        <Card.Body className="px-0 pb-2 ">
            <Table bordered size="sm" className="brandQtyTable">
                <thead>
                    <tr className="table-primary">
                        <th style={{ width: '110px' }}>Id</th>
                        <th style={{ width: '180px' }}>DESC</th>
                        <th>Currency</th>
                        <th>Date</th>
                        <th>Amount</th>
                        <th style={{ width: '80px' }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td data-label="Id">CN_/23-24</td>
                        <td data-label="DESC">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</td>
                        <td data-label="Currency">INR</td>
                        <td data-label="Date">
                            <p class="m-0"><small>Issue Date:  20/02/2025</small> </p>
                            <p class="m-0"><small class="text-danger">Due Date:    02/03/2025</small></p>
                        </td>
                        <td data-label="Amount">
                            <p class="m-0"><small>Cost: </small> <b>40000</b></p>
                            <p class="m-0"><small>Tax Type: </small> <b>GST</b></p>
                            <p class="m-0"><small>Tax: </small> <b>0</b></p>
                            <p class="m-0"><small>Total: </small> <b>40000</b></p>
                        </td>
                        <td className="text-center">
                            <Button
                                title="View"
                                icon="pi pi-eye"
                                className="p-0 border-0"
                                outlined
                            />
                        </td>
                    </tr>
                </tbody>
            </Table>
        </Card.Body>
    </Card>
);




// Default Component for Empty Selection
const DefaultContent = () => (
    <Card className="view-card">
        <h5>Welcome</h5>
        <p>Please select a section from the list.</p>
    </Card>
);

// Main Component
const BrandbookData = ({ brandId }) => {
    const { accessToken, role } = useAuth();

    const [submitLoading, setSubmitLoading] = useState(false); // New state for submit button
    const [editDialogVisible, setEditDialogVisible] = useState(false);
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog
    const allowedRoles = [
        'Founder', 'Admin', 'SuperAdmin', 'HumanResource',
        'Social_Media_Manager', 'Task_manager'
    ];


    // Retrieve selected index from localStorage or default to 0
    const [selectedIndex, setSelectedIndex] = useState(() => {
        return parseInt(localStorage.getItem(`selectedIndex_${brandId}`), 10) || 0;
    });

    // Define the menu items and their corresponding components
    const sections = [
        { title: "Brand Overview", component: <BrandOverview brandId={brandId} /> },
        { title: "Brand Identity", component: <BrandIdentity brandId={brandId} /> },
        { title: "Target Audience", component: <TargetAudience brandId={brandId} /> },
        { title: "Social Media Strategy", component: <SocialMediaStrategy brandId={brandId} /> },
        { title: "Visual & Creative Guidelines", component: <VisualCreativeGuidelines brandId={brandId} /> },
        { title: "Influencer & Community Engagement", component: <InfluencerCommunityEngagement brandId={brandId} /> },
        { title: "Advertising & Performance Tracking", component: <AdvertisingTracking brandId={brandId} /> },
        { title: "Campaign Planning & Execution", component: <CampaignPlanning brandId={brandId} /> },
        { title: "Additional Notes & Resources", component: <AdditionalNotesResources brandId={brandId} /> },
        { title: "Projects", component: <BrandProjects brandId={brandId} /> },
        { title: "Post History", component: <PostHistory brandId={brandId} /> },
        { title: "Minutes of Meeting", component: <MinutesofMeeting brandId={brandId} /> },
        { title: "Quotation List view", component: <QuotationListview brandId={brandId} /> },
    ];
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    // Store selected index in localStorage
    useEffect(() => {
        localStorage.setItem(`selectedIndex_${brandId}`, selectedIndex);
    }, [selectedIndex, brandId]);

    // State for Brand Managers (Social Media Managers)
    const [brandmanagers, setBrandmanagers] = useState([]);

    // State for Brand Associates (Other Selected Types)
    const [brandassociates, setBrandassociates] = useState([]);
    const [selectedAssociates, setSelectedAssociates] = useState([]);


    // Fetch brand associates on mount
    const fetchBrandAssociates = async () => {
        try {
            const response = await axios.get(`${config.apiBASEURL}/BrandBookRoutes/brand-associates/${brandId}`, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });

            const formatted = response.data.map(item => ({
                id: item.Associate_user_id || item.user?.user_id,
                BrandAssociateId: item.BrandAssociateId,
                name: `${item.user?.first_name || ''} ${item.user?.last_name || ''}`,
                Associate_user_id: item.Associate_user_id || item.user?.user_id,
                Associate_name: `${item.user?.first_name || ''} ${item.user?.last_name || ''}`,
                Associate_type: item.Associate_type || "Brand Associate",
                user: item.user // Keep the user object for rendering AvatarGroup
            }));

            setSelectedAssociates(formatted);
        } catch (error) {
            console.error("Error fetching brand associates:", error);
        }
    };

    useEffect(() => {
        if (brandId) fetchBrandAssociates();
    }, [brandId]);


    useEffect(() => {
        fetchBrandAssociates();
    }, [brandId]);






    const handleSelect = (selectedUsers, type) => {
        setSelectedAssociates(prev => {
            const otherTypes = prev.filter(user => user.Associate_type !== type);

            const newUsers = selectedUsers.map(user => ({
                id: user.id,
                name: user.name,
                Associate_user_id: user.id,
                Associate_name: user.name,
                Associate_type: type,
            }));

            return [...otherTypes, ...newUsers];
        });
    };


    // Fetch Brand Managers (Social Media Managers)
    useEffect(() => {
        const fetchBrandManagers = async () => {
            try {
                const response = await fetch(`${config.apiBASEURL}/BrandBookRoutes/users/social-media-managers`, {
                    headers: { Authorization: `Bearer ${accessToken}` },
                });
                const data = await response.json();
                if (response.ok) {
                    const formattedData = data.map(user => ({
                        id: user.user_id,  // Store correct user ID
                        name: `${user.first_name} ${user.last_name}`, // Ensure name is correct
                        Associate_user_id: user.user_id,  // Ensure correct mapping for API
                        Associate_name: `${user.first_name} ${user.last_name}`,
                        Associate_type: "Brand Manager",
                    }));
                    setBrandmanagers(formattedData);
                }
            } catch (error) {
                console.error("Error fetching Brand Managers:", error);
            }
        };

        fetchBrandManagers();
    }, [accessToken]);


    // Fetch Brand Associates (Department_Head, Employee, Task_manager)
    useEffect(() => {
        const fetchBrandassociates = async () => {
            try {
                const response = await fetch(`${config.apiBASEURL}/BrandBookRoutes/users/selected-types`, {
                    headers: { Authorization: `Bearer ${accessToken}` },
                });
                const data = await response.json();
                if (response.ok) {
                    const formattedData = data.map(user => ({
                        id: user.user_id,  // Store correct user ID
                        name: `${user.first_name} ${user.last_name}`, // Ensure name is correct
                        Associate_user_id: user.user_id,  // Ensure correct mapping for API
                        Associate_name: `${user.first_name} ${user.last_name}`,
                        Associate_type: "Brand Associate",
                    }));
                    setBrandassociates(formattedData);
                }
            } catch (error) {
                console.error("Error fetching Brand Associates:", error);
            }
        };

        fetchBrandassociates();
    }, [accessToken]);

    const handleEditClick = () => {
        setEditDialogVisible(true);
    };



    const handleSubmit = async () => {
        setSubmitLoading(true); // Start loading
        try {
            // Map selectedAssociates to the required format for backend
            const associatesPayload = selectedAssociates.map(associate => ({
                Associate_user_id: associate.Associate_user_id,
                Associate_type: associate.Associate_type,
                BrandAssociateId: associate.BrandAssociateId || null // send null if creating new
            }));

            const response = await axios.put(
                `${config.apiBASEURL}/BrandBookRoutes/brand-associates/update`,
                {
                    brand_id: brandId,
                    associates: associatesPayload
                },
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );

            if (response.status === 200) {
                setEditDialogVisible(false);
                setVideoDialogVisible(true);
                setTimeout(() => {
                    setVideoDialogVisible(false);
                    fetchBrandAssociates();
                }, 5000);
            }
        } catch (error) {
            console.error("Error updating brand overview:", error);
            setVideocrossDialogVisible(true);
            setTimeout(() => {
                setVideocrossDialogVisible(false);
            }, 5000);
        } finally {
            setSubmitLoading(false); // Stop loading
        }
    };




    return (
        <>

            <Row>
                <Col md={12} lg={12} className="mb-5 text-end text-secondary d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <p className="mb-0 text-black me-2">
                            <small>
                                Brand Manager{selectedAssociates.length > 1 ? 's' : ''}/Associate{selectedAssociates.length > 1 ? 's' : ''} :
                            </small>
                        </p>
                        <AvatarGroup>
                            {selectedAssociates.length > 0 ? (
                                selectedAssociates.map((manager, index) => {
                                    const tooltipId = `tooltip_${index}`;
                                    const { user, Associate_name, Associate_type } = manager;

                                    return (
                                        <div key={manager.id} className="d-inline-block position-relative">
                                            <Avatar
                                                image={user?.profileImage?.image_url || noUserImg}
                                                shape="circle"
                                                size="30"
                                                data-pr-tooltip={`${Associate_name} - ${Associate_type}`}
                                                data-pr-position="top"
                                                id={tooltipId}
                                            />
                                            <Tooltip target={`#${tooltipId}`} />
                                        </div>
                                    );
                                })
                            ) : (
                                <p className="mb-0 text-muted"><small>No managers assigned</small></p>
                            )}
                        </AvatarGroup>
                    </div>


                    <small className="text-warning ">
                        {allowedRoles.includes(role) && (
                            <Button
                                title="Edit Brand Managers"
                                icon="pi pi-pencil"
                                className="p-0 border-0"
                                text
                                severity="help"
                                onClick={handleEditClick}
                            />
                        )}
                    </small>

                </Col>
                {/* Sidebar List */}
                <Col md={4} lg={3} className="mb-3">
                    {isMobile ? (
                        <Dropdown
                            value={sections[selectedIndex]}
                            options={sections}
                            optionLabel="title"
                            onChange={(e) => setSelectedIndex(sections.indexOf(e.value))}
                            placeholder="Select a Section"
                            style={{ width: "100%", marginBottom: "10px" }}
                        />
                    ) : (
                        <ul className="bookpageList sticky-top">
                            {sections.map((section, index) => (
                                <li
                                    key={index}
                                    className={selectedIndex === index ? "active" : ""}
                                    onClick={() => setSelectedIndex(index)}
                                    style={{ cursor: "pointer", padding: "8px", listStyle: "none" }}
                                >
                                    {section.title}
                                    <i className="pi pi-arrow-right"></i>
                                </li>
                            ))}
                        </ul>
                    )}
                </Col>

                {/* Content Section */}
                <Col md={8} lg={9} className="overflow-hidden smallDiv">
                    {/* Prevent errors by ensuring valid index selection */}
                    {sections[selectedIndex]?.component || <DefaultContent />}
                </Col>
            </Row>
            {/* Edit Dialog */}
            <Dialog
                header="Add/Edit Brand Associates"
                visible={editDialogVisible}
                style={{ width: '420px' }}
                onHide={() => setEditDialogVisible(false)}
                footer={
                    <div>
                        <Button label="Cancel" icon="pi pi-times" severity="danger" onClick={() => setEditDialogVisible(false)} className="p-button-text py-2" />
                        <Button
                            label={submitLoading ? "Saving..." : "Save"}
                            icon={submitLoading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                            severity="success"
                            onClick={handleSubmit}
                            disabled={submitLoading}
                            autoFocus
                            className="py-2"
                        />
                    </div>
                }
            >
                <Row style={{ height: 'auto', overflowY: 'auto' }}>
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Brand Manager & Point of Contact</Form.Label>
                        <MultiSelect
                            value={selectedAssociates.filter(user => user.Associate_type === 'Brand Manager')}
                            onChange={(e) => handleSelect(e.value, 'Brand Manager')}
                            options={brandmanagers}
                            optionLabel="name"  // Make sure "name" is correctly mapped
                            dataKey="id"  // Ensure unique identification for checked status
                            filter
                            placeholder="Select Brand Managers"
                            maxSelectedLabels={3}
                            display="chip"
                        />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Brand Associate</Form.Label>
                        <MultiSelect
                            value={selectedAssociates.filter(user => user.Associate_type === 'Brand Associate')}
                            onChange={(e) => handleSelect(e.value, 'Brand Associate')}
                            options={brandassociates}
                            optionLabel="name"
                            dataKey="id"  // Ensures correct checkboxes and selection
                            filter
                            placeholder="Select Brand Associates"
                            maxSelectedLabels={3}
                            display="chip"
                        />
                    </Col>
                </Row>
            </Dialog>

            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>


            <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideocrossDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
            </Dialog>

        </>
    );
};

export default BrandbookData;
